import { optionShowModalActions } from './showModalSlice';

export default {
    ...optionShowModalActions,
};
